/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchRunResultPaymentGroupsInnerTotals } from './BatchRunResultPaymentGroupsInnerTotals';
import {
    BatchRunResultPaymentGroupsInnerTotalsFromJSON,
    BatchRunResultPaymentGroupsInnerTotalsFromJSONTyped,
    BatchRunResultPaymentGroupsInnerTotalsToJSON,
    BatchRunResultPaymentGroupsInnerTotalsToJSONTyped,
} from './BatchRunResultPaymentGroupsInnerTotals';

/**
 * 
 * @export
 * @interface BatchRunResultPaymentGroupsInner
 */
export interface BatchRunResultPaymentGroupsInner {
    /**
     * payment_group の識別子（UUID文字列）
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    groupId: string;
    /**
     * payment_group_name（支払通知書や成果物の表示名）
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    groupName: string;
    /**
     * company_name（会社名）
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    companyName: string;
    /**
     * ペイメントグループ請求書番号
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    invoiceNo: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    bankName: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    branchName: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    branchNum: string;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    bankAccountType: number;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    bankAccountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    bankAccountName: string;
    /**
     * 
     * @type {BatchRunResultPaymentGroupsInnerTotals}
     * @memberof BatchRunResultPaymentGroupsInner
     */
    totals: BatchRunResultPaymentGroupsInnerTotals;
}

/**
 * Check if a given object implements the BatchRunResultPaymentGroupsInner interface.
 */
export function instanceOfBatchRunResultPaymentGroupsInner(value: object): value is BatchRunResultPaymentGroupsInner {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('invoiceNo' in value) || value['invoiceNo'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('branchName' in value) || value['branchName'] === undefined) return false;
    if (!('branchNum' in value) || value['branchNum'] === undefined) return false;
    if (!('bankAccountType' in value) || value['bankAccountType'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('bankAccountName' in value) || value['bankAccountName'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    return true;
}

export function BatchRunResultPaymentGroupsInnerFromJSON(json: any): BatchRunResultPaymentGroupsInner {
    return BatchRunResultPaymentGroupsInnerFromJSONTyped(json, false);
}

export function BatchRunResultPaymentGroupsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultPaymentGroupsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'groupName': json['group_name'],
        'companyName': json['company_name'],
        'invoiceNo': json['invoice_no'],
        'bankName': json['bank_name'],
        'branchName': json['branch_name'],
        'branchNum': json['branch_num'],
        'bankAccountType': json['bank_account_type'],
        'bankAccountNumber': json['bank_account_number'],
        'bankAccountName': json['bank_account_name'],
        'totals': BatchRunResultPaymentGroupsInnerTotalsFromJSON(json['totals']),
    };
}

export function BatchRunResultPaymentGroupsInnerToJSON(json: any): BatchRunResultPaymentGroupsInner {
    return BatchRunResultPaymentGroupsInnerToJSONTyped(json, false);
}

export function BatchRunResultPaymentGroupsInnerToJSONTyped(value?: BatchRunResultPaymentGroupsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'group_name': value['groupName'],
        'company_name': value['companyName'],
        'invoice_no': value['invoiceNo'],
        'bank_name': value['bankName'],
        'branch_name': value['branchName'],
        'branch_num': value['branchNum'],
        'bank_account_type': value['bankAccountType'],
        'bank_account_number': value['bankAccountNumber'],
        'bank_account_name': value['bankAccountName'],
        'totals': BatchRunResultPaymentGroupsInnerTotalsToJSON(value['totals']),
    };
}

